/**
 * Leaguemate Scouting — S3 FAAB posture (pure, no I/O).
 *
 * spent% = Σ winning waiver_bid ÷ Σ FAAB budget, BOTH summed over the IDENTICAL
 * tx league set (the §7c denominator fix — never reuse a different league set
 * for the budget). Bands from scoutConfig (provisional).
 */

import {
  FAAB_HOARDER_MAX_PCT,
  FAAB_AGGRESSIVE_MIN_PCT,
} from "./scoutConfig.js";

/**
 * @param leagues scoutDeepFetch per-league rows { roster_id, faabBudget, completeTx }
 * @returns { spent, budget, spentPct, band, winningBids, maxBid, topBidShare, leaguesCounted }
 */
export function computeFaab(leagues) {
  let spent = 0;
  let budget = 0;
  let leaguesCounted = 0;
  const bids = [];

  for (const lg of leagues || []) {
    const rid = lg.roster_id;
    // Budget and spend MUST come from the same league row → identical set.
    budget += lg.faabBudget || 0;
    leaguesCounted++;
    for (const t of lg.completeTx || []) {
      if (t.type !== "waiver") continue;
      const adds = t.adds || {};
      // This manager won the waiver iff a player was added to their roster_id.
      const won = Object.values(adds).includes(rid);
      if (!won) continue;
      const bid = (t.settings || {}).waiver_bid || 0;
      spent += bid;
      bids.push(bid);
    }
  }

  const spentPct = budget > 0 ? Math.round((100 * spent) / budget * 10) / 10 : null;
  const band =
    spentPct == null
      ? "unknown"
      : spentPct < FAAB_HOARDER_MAX_PCT
      ? "hoarder"
      : spentPct > FAAB_AGGRESSIVE_MIN_PCT
      ? "aggressive"
      : "balanced";

  const maxBid = bids.length ? Math.max(...bids) : 0;
  const topBidShare = spent > 0 ? Math.round((maxBid / spent) * 100) / 100 : null;

  return {
    spent,
    budget,
    spentPct,
    band,
    winningBids: bids.length,
    maxBid,
    topBidShare, // bid concentration: share of total spend in the single biggest bid
    leaguesCounted,
  };
}
